import React from 'react';
import {Platform} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {SharePlanButton} from '../SharePlanButton/SharePlanButton';

import {useSharePlanSection} from './SharePlanSection.hook';
import {styles} from './SharePlanSection.style';

interface SharePlanSectionProps {
  onShowInfoPopover: () => void;
  onNavigate: () => void;
  lastPaidRank: string;
  highestAchievedRank: string;
  coachCurrentRank: string;
  coachID: string;
}

export const SharePlanSection: React.FC<SharePlanSectionProps> = ({
  onShowInfoPopover = () => {},
  onNavigate = () => {},
  lastPaidRank = '',
  highestAchievedRank = '',
  coachCurrentRank = '',
  coachID = '',
}) => {
  const {onInfoPress, ts} = useSharePlanSection({
    onShowInfoPopover,
  });
  const isWeb = Platform.OS === 'web';
  return (
    <>
      <MetricSection
        analyticsTitle="SharePlan"
        infoAccessibilityLabel={ts(
          'accessibilityLabel',
          'SharePlan Section Information button',
        )}
        title={ts('heading', 'Share a Plan')}
        onInfoPress={onInfoPress}
        testID={MetricsSection.metricSectionSharePlan}
        containerStyle={isWeb ? styles.webContainer : undefined}
        headerStyle={isWeb ? styles.webHeader : undefined}
      />

      <SharePlanButton
        onNavigate={onNavigate}
        lastPaidRank={lastPaidRank}
        highestAchievedRank={highestAchievedRank}
        coachCurrentRank={coachCurrentRank}
        coachID={coachID}
      />
    </>
  );
};

export default SharePlanSection;
